import { Button, Card, Stack, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	description: string;
	disabled?: boolean;
	navPath: string;
	ilPath: string;
};

export const DemoItemCard = ({ title, description, ilPath, navPath, disabled }: Props) => {
	const navigate = useNavigate();
	const { translate, currentLang } = useLocales();

	const onClick = () => {
		navigate({ to: `${navPath}?locale=${currentLang.value}` });
	};

	const knowMore = () => {
		window.open("https://docs.vumi.io/", "_blank");
	};

	return (
		<Card sx={{ maxWidth: 400, pb: 4, height: 500, display: "flex", flexDirection: "column" }}>
			<Image src={ilPath} sx={{ maxHeight: 250 }} />
			<Stack sx={{ px: 4, mt: 2, flexGrow: 1 }} justifyContent={"space-between"}>
				<Stack>
					<Typography variant='h5'>{title}</Typography>
					<Typography variant='body2' color='text.secondary' sx={{ mt: 1.5 }}>
						{description}
					</Typography>
				</Stack>
				<Stack flexDirection='row' alignItems='center' gap={4}>
					<Button variant='contained' onClick={onClick} disabled={disabled}>
						{disabled ? translate("demo.soon") : translate("demo.test_demo")}
					</Button>
					{!disabled && (
						<Button variant='text' onClick={knowMore}>
							{"Saber más"}
						</Button>
					)}
				</Stack>
			</Stack>
		</Card>
	);
};

export default DemoItemCard;
